export var EContactCustomId;
(function (EContactCustomId) {
    EContactCustomId["Me"] = "me";
    EContactCustomId["MeMaster"] = "me-master";
    EContactCustomId["Support"] = "support";
    EContactCustomId["Legal"] = "legal";
    EContactCustomId["Financial"] = "financial";
    EContactCustomId["Billing"] = "billing";
})(EContactCustomId || (EContactCustomId = {}));
